;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller(
      'VulnerabilityTrendReportManagePopoverCtrl',
      VulnerabilityTrendReportManagePopoverCtrl
    )

  function VulnerabilityTrendReportManagePopoverCtrl(
    $translate,
    dialogs,
    logger,
    ErrorService,
    reportFilterService,
    VulnerabilityTrendReportFactory
  ) {
    var vm = this

    vm.prev_filter_name = ''
    vm.filter_name = ''
    vm.view = null

    vm.closePopover = closePopover
    vm.init = init
    vm.removeFilter = removeFilter
    vm.saveFilter = saveFilter

    function closePopover(popover) {
      popover.save = false
    }

    function init(view) {
      vm.view = view
      if (vm.view.selected_view != null && vm.view.is_edited == false) {
        vm.filter_name = view.selected_view.name
        vm.prev_filter_name = view.selected_view.name
      }
    }

    function removeFilter(popover, callback) {
      var transl = {
        detail_vulnerabilityTrend_removeReportSuccess: $translate.instant(
          'detail_vulnerabilityTrend_removeReportSuccess'
        ),
        action_cancel: $translate.instant('action_cancel'),
        action_remove: $translate.instant('action_remove'),
        title_vulnerabilityTrend_removeSavedReport: $translate.instant(
          'title_vulnerabilityTrend_removeSavedReport'
        ),
        variable_vulnerabilityTrend_removeSavedReportConfirmation:
          $translate.instant(
            'variable_vulnerabilityTrend_removeSavedReportConfirmation',
            { reportName: vm.view.selected_view.name }
          )
      }

      var body =
        transl.variable_vulnerabilityTrend_removeSavedReportConfirmation

      closePopover(popover)

      dialogs
        .confirm(transl.title_vulnerabilityTrend_removeSavedReport, body, {
          size: 'md-sm',
          yes: transl.action_remove,
          no: transl.action_cancel
        })
        .result.then(function () {
          return VulnerabilityTrendReportFactory.deleteFilter(
            vm.view.selected_view.value
          )
        })
        .then(function () {
          logger.logSuccess(
            transl.detail_vulnerabilityTrend_removeReportSuccess
          )

          if (angular.isFunction(callback)) {
            callback()
          }
        })
        .catch(ErrorService.processError)
    }

    function saveFilter(popover, callback) {
      var transl = {
        detail_vulnerabilityTrend_saveReportSuccess: $translate.instant(
          'detail_vulnerabilityTrend_saveReportSuccess'
        ),
        detail_vulnerabilityTrend_saveReportError: $translate.instant(
          'detail_vulnerabilityTrend_saveReportError'
        )
      }

      var request = null

      if (
        vm.view.selected_view == null ||
        (vm.view.selected_view != null && vm.view.is_edited)
      ) {
        request = VulnerabilityTrendReportFactory.saveFilter(_buildData())
      } else {
        var data = [
          {
            id: vm.view.selected_view.value,
            view_name: vm.filter_name
          }
        ]

        request = VulnerabilityTrendReportFactory.bulkEdit(data)
      }

      if (request != null) {
        request
          .then(
            function () {
              logger.logSuccess(
                transl.detail_vulnerabilityTrend_saveReportSuccess
              )
              if (callback) {
                callback(vm.filter_name)
              }

              if (vm.view.selected_view != null) {
                vm.view.selected_view.name = vm.filter_name
              }
            },
            function () {
              logger.logError(transl.detail_vulnerabilityTrend_saveReportError)
            }
          )
          .finally(function () {
            closePopover(popover)
          })
      }
    }

    function _buildData() {
      return {
        view_name: vm.filter_name,
        filter_view: JSON.stringify(reportFilterService.createRequest()),
        interval: reportFilterService.getRange()
      }
    }
  }
}).call(this)
